import React, { Component } from "react";
import { connect } from "react-redux";
import { ExcelRenderer } from "react-excel-renderer";
import Helper from "../../helper/Helper";
import Table from "../table";
import Pannel from "../pannel";
import ReturnsTable from "../returnsTable";
import UploadFileButton from "../../../../../common/buttons/uploadFileButton";
import CustomSelector from "../../../../../common/customSelectorOptions";
import Spinner from "../../../../../common/spinner";
import helper from "../../../../helper.modifyPortfolio";
import "./Analyze.styles.scss";

class Analyze extends Component {
  state = {
    showUploadModel: true,
    showAddRowModel: false,
    current_holding_error: false,
    current_holding_name: "",
    historical_holding_error: false,
    historical_holding_name: "",
    data: [],
    portfolioTableActive: true,
    selectTypeData: [],
    IQCIOSelectionList: [],
    myPortfolioSelectionList: [],
    historical_upload_error: false,
    historical_error_name: "",
    historical_data_empty: false,
    historical_few_empty_columns: false,
    wrongXLSXFormat: false,
  };

  componentWillMount() {
    this.setDefaultListOptions(this.props);
  }
  componentDidMount() {
    this.modelChangeHandler({ active: "predefined" });
  }
  componentWillReceiveProps(nextProps) {
    this.setDefaultListOptions(nextProps);
  }

  setDefaultListOptions = (props) => {
    const {
      modelportfolios,
      setUniverseLiteModelId,
      setActiveGoal,
      setBenchmarkName,
      setPortfolioID,
      selected_predefined_model,
      list_of_myPortfolios,
      setUniverseLitePreDefinedModel,
      setUniverseLiteModelName,
      model_id,
    } = props;
    const { myPortfolioSelectionList } = this.state;
    let iqcio_model_list,
      my_portfolio_list = [];
    // setting select list data
    if (
      (modelportfolios && modelportfolios.length > 0) ||
      (modelportfolios &&
        modelportfolios.length > 0 &&
        selected_predefined_model === "iqcioModel")
    ) {
      let arr = [];
      for (let i = 0; i < modelportfolios.length; i++) {
        let obj = {};
        obj[modelportfolios[i]["id"]] = modelportfolios[i]["data"][0][
          "scenario_name"
        ]
          ? modelportfolios[i]["data"][0]["scenario_name"]
          : modelportfolios[i]["data"][0]["benchmark"];
        arr.push(obj);
      }
      this.setState({
        IQCIOSelectionList: arr,
      });

      //set default id

      let id = modelportfolios[0]["id"];
      if (!model_id) {
        setUniverseLiteModelId(id);

        // let defaultSelectOption = "";
        // if (arr.length) {
        //   defaultSelectOption = Object.values(
        //     arr.filter((e) => Object.keys(e) == id)[0]
        //   )[0];
        // }
        let name = modelportfolios[0]["data"][0]["scenario_name"];
        setUniverseLiteModelName(name);

        setActiveGoal(modelportfolios[0]);
        setBenchmarkName(modelportfolios[0].data[0].benchmark_name);
        setPortfolioID(id);
      }
      iqcio_model_list = arr;
    }
    if (
      list_of_myPortfolios &&
      list_of_myPortfolios.length > 0 &&
      (myPortfolioSelectionList.length === 0 ||
        selected_predefined_model === "myPortfolio")
    ) {
      if (!list_of_myPortfolios) return;
      let arr = [];
      for (let i = 0; i < list_of_myPortfolios.length; i++) {
        let obj = {};
        if (list_of_myPortfolios[i]["scenario_name"]) {
          obj[list_of_myPortfolios[i]["scenario_id"]] =
            list_of_myPortfolios[i]["scenario_name"];
          arr.push(obj);
        }
      }
      this.setState({
        myPortfolioSelectionList: arr,
      });

      my_portfolio_list = arr;

      if (
        selected_predefined_model === "myPortfolio" &&
        list_of_myPortfolios.length > 0
      ) {
        // set default model
        let id = list_of_myPortfolios[0]["scenario_id"];
        let name = list_of_myPortfolios[0]["scenario_name"];
        if (!model_id) {
          this.selectModelHandler({ name, id, index: 0, myPortfolio: true });
        }
      }
    }

    if (selected_predefined_model == "myPortfolio") {
      this.setState({
        selectTypeData: my_portfolio_list,
      });
    } else {
      this.setState({
        selectTypeData: iqcio_model_list,
      });
    }
    if (
      iqcio_model_list &&
      iqcio_model_list.length &&
      my_portfolio_list &&
      my_portfolio_list.length
    ) {
      let name = modelportfolios[0]["data"][0]["scenario_name"];
      if (model_id == "") {
        setUniverseLiteModelName(name);
      }
      setUniverseLitePreDefinedModel({ iqcio_model_list, my_portfolio_list });
    }
  };

  _getTodaysDateWithZeroHour = () => {
    let nowDate = new Date(new Date().setHours(0, 0, 0, 0));
    return nowDate;
  };
  xlsxHandler = (e, type) => {
    let file = e.target.files[0];
    if (
      file &&
      file.name &&
      (file.name.includes(".xls") || file.name.includes(".xlsx"))
    ) {
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("Error");
        } else {
          const { setUniverseLitePortfolio } = this.props;
          this.setState({
            current_holding_error: false,
            historical_holding_error: false,
          });

          //remove empty arrays
          var response = res["rows"].filter((d) => d.length);
          // checks if any null or empty data and removes it
          //   let resData = response.filter((d) => d.length);
          //   let filtered = resData.map((d) => {
          //     return d.filter((el) => el != null);
          //   });

          var heading = response[0].map((e) => e.toLowerCase().trim());
          // remove heading
          var data = response.slice(1, response.length);

          const getIndex = (string) => {
            return heading.indexOf(string);
          };

          let security_index =
            getIndex("security name") === -1
              ? getIndex("security")
              : getIndex("security name");
          let symbol_index = getIndex("symbol");
          let fund_type_index = getIndex("fund type");
          let classification_index = getIndex("classification");
          let asset_class_index = getIndex("asset class");
          let style_index = getIndex("style");
          let exchange_index = getIndex("exchange");
          let core_allocation_index = getIndex("allocation");
          let date_index = getIndex("date");

          // getting which column has error
          const getStatus = () => {
            if (security_index === -1) {
              setValue("security");
              return;
            } else if (symbol_index === -1) {
              setValue("symbol");
              return;
            } else if (exchange_index === -1) {
              setValue("exchange");
              return;
            } else if (core_allocation_index === -1) {
              setValue("allocation");
              return;
            }
            //  else if (type === "historical_holding" && date_index == -1) {
            //   setValue("date");
            //   return;
            // }
          };
          const setValue = (name) => {
            // if (type === "current_holding") {
            this.setState({
              current_holding_name: name,
            });
            // } else {
            //   this.setState({
            //     historical_holding_name: name,
            //   });
            // }
          };
          getStatus();

          let current =
            (heading[security_index] === "security name" ||
              heading[security_index] === "security" ||
              security_index !== -1) &&
            (heading[symbol_index] === "symbol" || symbol_index !== -1) &&
            // (heading[exchange_index] == "exchange" || exchange_index !== -1) &&
            (heading[core_allocation_index] === "allocation" ||
              core_allocation_index !== -1);

          // let historical = heading[date_index] == "date" || date_index !== -1;

          if (current) {
            this.setState({
              showUploadModel: false,
            });

            if (heading.length > 0 && current) {
              let arr = [];
              for (let i = 0; i < data.length; i++) {
                let obj = {};
                obj.fund_name = data[i][security_index];
                obj.symbol = data[i][symbol_index];
                obj.new_fund_type = data[i][fund_type_index];
                obj.new_classification = data[i][classification_index];
                obj.fund_asset_class_focus = data[i][asset_class_index];
                obj.new_style = data[i][style_index];
                obj.exchange = data[i][exchange_index]
                  ? data[i][exchange_index]
                  : "";
                obj.val = data[i][core_allocation_index]
                  ? data[i][core_allocation_index]
                  : null;
                obj.date = data[i][date_index]
                  ? Helper.ExcelDateToJSDate(`${data[i][date_index]}`)
                  : this._getTodaysDateWithZeroHour();

                arr.push(obj);
              }
              //  setting default cash row
              let cashFind = arr.filter(
                (d) => d.fund_name.toLowerCase() === "cash"
              );

              if (cashFind.length === 0) {
                let obj = {
                  fund_name: "Cash",
                  symbol: "IQCASH",
                  new_fund_type: "Cash",
                  new_classification: "Cash",
                  fund_asset_class_focus: "Cash",
                  new_style: "Cash",
                  val: 0,
                  date: new Date(),
                };
                let ar = [obj, ...arr];
                setUniverseLitePortfolio(ar);
                this.setState({
                  data: ar,
                  showAddRowModel: false,
                });
              } else {
                setUniverseLitePortfolio(arr);
                this.setState({
                  data: arr,
                  showAddRowModel: false,
                });
              }

              // setting display original portfolio data in portfolio dashboard
              this.props.setOrigPortfolioDisplay(true);
              //resetting
              this.props.setComparePortfolioAnalyzeID(0);
              this.props.setAnalyseYourPortfolio([], [], []);
              this.props.setAnalyseIQCIOPortfolio([], [], []);
              this.props.resetClientBacktestData({});
              this.props.resetAnalyzeAnalysisPerfHistmetrics([]);
            }
          } else {
            console.log("invalid data");
            document.getElementById("upload_scenario_file04").value = "";
            // document.getElementById("upload_scenario_file05").value = "";
            // if (type == "current_holding") {
            this.setState({ current_holding_error: true });
            // } else {
            //   this.setState({ historical_holding_error: true });
            // }
          }
        }
      });
    } else {
      this.setState({
        wrongXLSXFormat: true,
      });
      setTimeout(() => {
        this.setState({
          wrongXLSXFormat: false,
        });
      }, 5000);
      document.getElementById("upload_scenario_file04").value = "";
    }
  };
  uploadModelToggleHandler = () => {
    this.setState({
      showUploadModel: !this.state.showUploadModel,
    });
  };

  addRowToggleHandler = () => {
    this.setState({
      showAddRowModel: !this.state.showAddRowModel,
    });
  };

  addRowHandler = () => {
    this.setState({
      showAddRowModel: !this.state.showAddRowModel,
    });
  };

  Error = ({ txt }) => {
    return (
      <div className="select_type_error">
        <p className="dataWarning">{txt}</p>
      </div>
    );
  };

  callBack = () => {
    this.setState({
      portfolioTableActive: false,
    });
  };

  selectModelHandler = ({ name, id, index, myPortfolio = false }) => {
    const {
      setUniverseLiteModelId,
      setUniverseLiteModelName,
      setPortfolioID,
      setActiveGoal,
      setBenchmarkName,
      modelportfolios,
      list_of_myPortfolios,
      setDirectReviewModelPortfolio,
      selected_predefined_model,
      setModelPortfolios,
    } = this.props;

    setUniverseLiteModelId(id);
    setUniverseLiteModelName(name);
    if (myPortfolio === false && selected_predefined_model === "iqcioModel") {
      setModelPortfolios(modelportfolios);
      setActiveGoal(modelportfolios[index]);
      setBenchmarkName(modelportfolios[index].data[0].benchmark_name);
      setPortfolioID(id);
    } else if (
      myPortfolio === true ||
      selected_predefined_model === "myPortfolio"
    ) {
      console.log(name, id);

      let filtered_data = list_of_myPortfolios.filter(
        (e) => e.scenario_id == id
      );
      let condition = filtered_data.length > 0;
      let optimization_params = condition
        ? {
            [id]: {
              benchmark: filtered_data[0]["benchmark"],
              max_beta: filtered_data[0]["beta"],
              max_vol: filtered_data[0]["max_vol"],
              min_return: filtered_data[0]["min_return"],
              upper_bounds: filtered_data[0]["upper_bounds"],
            },
          }
        : {};
      //
      let asset_class = condition
        ? helper.modify_backtest_params({
            data: filtered_data[0]["fund_asset_class_focus"],
          })
        : [];
      let fund_type = condition
        ? helper.modify_backtest_params({
            data: filtered_data[0]["fund_type"],
          })
        : [];
      let overall_focus = condition
        ? helper.modify_backtest_params({
            data: filtered_data[0]["overall_focus"],
          })
        : [];
      let styles = condition
        ? helper.modify_backtest_params({
            name: "style",
            data: filtered_data[0]["style"],
          })
        : [];

      setDirectReviewModelPortfolio({
        activePortfolioID: id,
        optimization_params,
        benchmark_name: filtered_data[0]["benchmark_name"],
        asset_class,
        fund_type,
        overall_focus,
        styles,
      });
    }
  };

  toggleButtonHandler = (status) => {
    this.setState({
      portfolioTableActive: status,
    });
  };

  //=========historical upload error messages handler ==============//
  pannel_UploadHistoricalReturns_ErrorHandler = (status, name) => {
    this.setState({
      historical_upload_error: status,
      historical_error_name: name,
    });
  };

  Empty_UploadHistoricalReturns_handler = (status) => {
    this.setState({
      historical_data_empty: status,
    });
  };
  uploaded_some_of_empty_columns = (status) => {
    this.setState({
      historical_few_empty_columns: status,
    });
  };

  //================================================================//
  myPortfolioModifyData = ({ data }) => {
    if (!data) return;
    let arr = [];
    for (let i = 0; i < data.length; i++) {
      let obj = {};
      if (data[i]["scenario_name"]) {
        obj[data[i]["scenario_id"]] = data[i]["scenario_name"];
        arr.push(obj);
      }
    }
    this.setState({
      myPortfolioSelectionList: arr,
    });
  };
  modelChangeHandler = ({ type }) => {
    const {
      modelportfolios,
      setUniverseLitePreDefinedModelSelected,
      setModelPortfolios,
    } = this.props;
    const { IQCIOSelectionList, myPortfolioSelectionList } = this.state;
    if (type === "iqcioModel") {
      setModelPortfolios(modelportfolios);
      this.setState({
        selectTypeData: IQCIOSelectionList,
      });
      setUniverseLitePreDefinedModelSelected("iqcioModel");

      // set default model
    } else if (type === "myPortfolio") {
      setUniverseLitePreDefinedModelSelected("myPortfolio");
      this.setState({
        selectTypeData: myPortfolioSelectionList,
      });

      // set default model
      // this.selectModelHandler({ name, id, index, myPortfolio: true });
    }
  };
  render() {
    const {
      showUploadModel,
      showAddRowModel,
      current_holding_error,
      current_holding_name,
      data,
      portfolioTableActive,
      selectTypeData,
      historical_upload_error,
      historical_error_name,
      historical_data_empty,
      historical_few_empty_columns,
      wrongXLSXFormat,
    } = this.state;
    const { selected_predefined_model, model_name } = this.props;

    return (
      <div className="analyze">
        <div className="analyze__model">
          <div
            className="analyze__model_heading"
            onClick={(e) => this.uploadModelToggleHandler(e)}
          >
            <div>UPLOAD HOLDINGS</div>
            {/* <div>UPLOAD HOLDINGS BY DATE</div> */}
            <div>
              SELECT A PRE-DEFINED MODEL{" "}
              <div style={{ float: "right" }}>
                <i
                  className={`fa fa-angle-double-${
                    showUploadModel ? "up" : "down"
                  }`}
                  aria-hidden="true"
                ></i>
              </div>
            </div>
          </div>
          {showUploadModel && (
            <div className="analyze__model_content">
              <div className="analyze__model_content_holder">
                <div className="analyze__model_content_holder_txt">
                  Please upload your current holdings in excel format. Please
                  make sure the portfolio xls you are uploading contains the 4
                  columns : <b>security name, symbol, exchange &amp; allocation</b>.
                  The allocations should add up to 100%.You can also upload an
                  excel with an additional <b>date</b> field to capture
                  historical holdings information. Alternately you could also
                  enter the securities one row at a time in the below table. &nbsp;
                    <a href="/assets/analyse_template.xls" download><b>[DOWNLOAD XLS TEMPLATE]</b></a>{" "}
                </div>
                {current_holding_error &&
                  this.Error({
                    txt: `${current_holding_name.toUpperCase()} column missing. Please make sure "${current_holding_name}"
                  column exists in the uploaded holdings excel.`,
                  })}
                {wrongXLSXFormat &&
                  this.Error({ txt: `Please upload xls/xlsx format data.` })}
                <div className="analyze__model_content_holder_btn">
                  <UploadFileButton
                    text="Upload Holdings"
                    onHoverStyle={true}
                    eventHandler={(e) => this.xlsxHandler(e, "current_holding")}
                    id="upload_scenario_file04"
                  />
                </div>

              </div>

              <div className="analyze__model_content_holder">
                <div className="analyze__model_content_holder_txt">
                  Please select a pre defined model to compare the portfolio
                  against.The below dropdown contains all models available for
                  comparison.
                  <p>
                    You can switch between models to to compare against in the
                    next step
                  </p>
                </div>
                <div className="analyze__model_content_holder_btn">
                  {selectTypeData && selectTypeData.length > 0 && model_name ? (
                    <CustomSelector
                      textAlign={"left"}
                      defaultText={model_name}
                      optionsList={selectTypeData}
                      changeHandler={(e) => this.selectModelHandler(e)}
                      showDifferentModels={true}
                      iqcioModelHandler={() =>
                        this.modelChangeHandler({ type: "iqcioModel" })
                      }
                      myPortfolioModelHandler={() =>
                        this.modelChangeHandler({ type: "myPortfolio" })
                      }
                      model={selected_predefined_model}
                    />
                  ) : (
                    <Spinner />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          <Pannel
            showAddRowModel={showAddRowModel}
            addRowHandler={this.addRowHandler}
            addRowToggleHandler={this.addRowToggleHandler}
            callBack={this.callBack}
            uploadErrorCallBack={
              this.pannel_UploadHistoricalReturns_ErrorHandler
            }
            uploadEmptyDataHandler={this.Empty_UploadHistoricalReturns_handler}
            uploadedEmptyCellHandler={this.uploaded_some_of_empty_columns}
          />
          {/* {historical_returns.length > 0 ? (
            <div className="analyze_returns_btn">
              <button
                className={
                  portfolioTableActive ? "analyze_returns_btn_active" : null
                }
                onClick={() => this.setState({ portfolioTableActive: true })}
              >
                Portfolio
              </button>
              <button
                className={
                  !portfolioTableActive ? "analyze_returns_btn_active" : null
                }
                onClick={() => this.setState({ portfolioTableActive: false })}
              >
                Returns
              </button>
            </div>
          ) : null} */}
          {portfolioTableActive ? (
            <Table
              filteredScenarioList={data}
              toggleButtonHandler={this.toggleButtonHandler}
              portfolioTableActive={portfolioTableActive}
              historical_upload_error={historical_upload_error}
              historical_error_name={historical_error_name}
              historical_data_empty={historical_data_empty}
              historical_few_empty_columns={historical_few_empty_columns}
            />
          ) : (
            <ReturnsTable
              toggleButtonHandler={this.toggleButtonHandler}
              portfolioTableActive={portfolioTableActive}
              historical_upload_error={historical_upload_error}
              historical_error_name={historical_error_name}
              historical_data_empty={historical_data_empty}
              historical_few_empty_columns={historical_few_empty_columns}
            />
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  ({
    create: {
      modelportfolios,
      steps: {
        universeLite: {
          historical_returns,
          predefined_models: { selected_predefined_model },
          model_id,
          model_name,
        },
      },
    },
    myPortfolios: { list_of_myPortfolios },
  }) => ({
    modelportfolios,
    historical_returns,
    list_of_myPortfolios,
    selected_predefined_model,
    model_id,
    model_name,
  }),
  (dispatch) => ({
    setUniverseLitePortfolio: (payload) =>
      dispatch({ type: "SET_UNIVERSE_LITE_PORTFOLIO", payload }),
    setUniverseLiteModelId: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_MODEL_ID",
        payload,
      }),
    setUniverseLiteModelName: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_MODEL_NAME",
        payload,
      }),
    setPortfolioID: (payload) =>
      dispatch({ type: "SET_PORTFOLIO_ID", payload }),
    setActiveGoal: (inv) => dispatch({ type: "SET_ACTIVE_GOAL", payload: inv }),
    setBenchmarkName: (payload) =>
      dispatch({ type: "SET_BENCHMARKNAME", payload }),
    // setting compare portfolio analyze id
    setComparePortfolioAnalyzeID: (payload) =>
      dispatch({ type: "SET_COMPARE_PORTFOLIO_ID_ANALYZE", payload }),
    setAnalyseYourPortfolio: (yourChartOptions, yourDrilldown, yourTable) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_COMPARE_YOUR_PORTFOLIOS",
        payload: { yourChartOptions, yourDrilldown, yourTable },
      }),

    setAnalyseIQCIOPortfolio: (iqcioChartOptions, iqcioDrilldown, iqcioTable) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_COMPARE_IQCIO_PORTFOLIOS",
        payload: { iqcioChartOptions, iqcioDrilldown, iqcioTable },
      }),
    resetClientBacktestData: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_CLIENT_BACKTEST_DATA",
        payload,
      }),
    resetAnalyzeAnalysisPerfHistmetrics: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_PERF_HISTMETRICS",
        payload,
      }),
    setOrigPortfolioDisplay: (payload) =>
      dispatch({
        type: "SET_ORIG_PORTFOLIO_DISPLAY",
        payload,
      }),
    setUniverseLitePreDefinedModelSelected: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_PRE_DEFINED_MODEL_SELECTED",
        payload,
      }),
    setUniverseLitePreDefinedModel: ({ iqcio_model_list, my_portfolio_list }) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_PRE_DEFINED_MODELS",
        payload: { iqcio_model_list, my_portfolio_list },
      }),
    setDirectReviewModelPortfolio: (payload) =>
      dispatch({ type: "SET_DIRECT_REVIEW_PORTFOLIO_MODELPORTFOLIO", payload }),
    setModelPortfolios: (modelportfolios) =>
      dispatch({ type: "SET_PORTFOLIOS", payload: modelportfolios }),
  })
)(Analyze);

//



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analyze/Analyze.jsx